import {fetchAddresses} from "@/store/api/api";

export default {
    namespaced: true,
    state: {
        id: null,
        addresses: [],
    },
    getters: {
        getAddresses: (state) => state.addresses,
        getAddressById: (state) => (id) =>
            state.addresses.find(address => address.id === id),
        getCurrentAddress: (state) =>
            state.addresses.find(address => address.id === state.id),
        isAddressExist: (state) => (id) =>
            state.addresses.some(address => address.id === id),
    },
    mutations: {
        setAddresses(state, payload) {
            state.addresses = payload;
        },
        setCurrentAddress(state, payload) {
            state.id = parseInt(payload);
        },
        clearAddress(state) {
            state.id = null;
        },
    },
    actions: {
        async fetchAddresses({commit}, options) {
            const addresses = await fetchAddresses(options);
            commit('setAddresses', addresses);
        },
        setCurrentAddress({commit, dispatch}, id) {
            commit('setCurrentAddress', id);
            dispatch('config/saveStateToLocalStorage', null, {root: true});
        },
        clearAddress({commit, dispatch}) {
            commit('clearAddress');
            dispatch('clearAddressDependencies');
            dispatch('config/saveStateToLocalStorage', null, {root: true});
        },
        clearAddressDependencies({dispatch}) {
            dispatch('item/clearItem', null, {root: true});
            dispatch('person/clearPerson', null, {root: true});
        }
    }
}
